import styled, { StyledComponentProps } from "styled-components";
import { cssMediaQueryBreakpoints } from "../config/breakpoints";
import { NoSelectStyles } from "../shared/styled/NoSelectStyles.styled";

interface IProps {
    height: number;
    width: number;
    smallHeight: number;
    smallWidth: number
}

export const PlayStandardIcon = (props: IProps & StyledComponentProps<"svg", any, {}, never>) => {
    return (
        <StyledSvg viewBox="0 0 38 39" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path d="M27.4843 18.0469L12.5539 9.08661C11.3239 8.35427 9.5 9.08661 9.5 10.8528V28.7735C9.5 30.4105 11.1966 31.4013 12.5539 30.5828L27.4843 21.6224C28.7992 20.804 28.7992 18.8654 27.4843 18.0469Z" />
        </StyledSvg>
    );
}

const StyledSvg = styled.svg<IProps>`
    ${NoSelectStyles}

    ${cssMediaQueryBreakpoints.small} {
        height: ${p => p.smallHeight}px;
        min-height: ${p => p.smallHeight}px;
        width: ${p => p.smallWidth}px;
        min-width: ${p => p.smallWidth}px;
        margin-right: 4px;
    }
    
    height: ${p => p.height}px;
    min-height: ${p => p.height}px;
    width: ${p => p.width}px;
    min-width: ${p => p.width}px;
    margin-right: 8px;
    cursor: pointer;
    fill: ${p => p.theme.playColor};
`